import RemoteCollection from "#root/utility/remote-collection";
import * as z from "zod";

export const ProductListSchema = z.object({
  id: z.number(),
  name: z.string(),
  type: z.string(),
  code: z.string().nullish(),
  category: z.string(),
  description: z.string().nullish(),
  vendorId: z.number().nullish(),
  vendor: z.object({}).nullish(), //Filled in by join below
});

export const ProductDetailSchema = ProductListSchema.extend({
  page: z.string().nullish(),
  profile: z.string().nullish(),
  defaultEntitlementOptions: z.object({}).nullish(),
  provides: z.string().nullish(),
  revenueAccount: z.string().nullish(),
  tags: z.array(z.string()).nullish(),
  listed: z.number().nullish(),
}).loose();

export type ProductListItem = z.output<typeof ProductListSchema>;
export type ProductDetailItem = z.output<typeof ProductDetailSchema>;
export const productCollection = new RemoteCollection("/api/product", ProductListSchema, ProductDetailSchema);
